import { createElementBlock as l, openBlock as o, createElementVNode as n } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(c, e) {
  return o(), l("svg", r, e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8.504 4.652C8.017 5.648 8 6.91 8 8q0 .072-.01.143h9.653A3.857 3.857 0 0 1 21.5 12v6.143A3.857 3.857 0 0 1 17.643 22H6.357A3.857 3.857 0 0 1 2.5 18.143V12a3.86 3.86 0 0 1 3.512-3.842A1 1 0 0 1 6 8v-.066c0-1.018-.001-2.714.708-4.161A4.6 4.6 0 0 1 8.54 1.779C9.408 1.27 10.5 1 11.846 1c1.284 0 2.338.247 3.187.711a4.58 4.58 0 0 1 1.845 1.855 1 1 0 1 1-1.756.959 2.58 2.58 0 0 0-1.049-1.059C13.583 3.197 12.875 3 11.846 3c-1.078 0-1.803.216-2.297.505a2.6 2.6 0 0 0-1.045 1.147m4.746 9.098c0 .474-.264.886-.653 1.098l.005.017.42 1.5a.5.5 0 0 1-.481.635h-1.082a.5.5 0 0 1-.481-.635l.42-1.5.005-.017a1.25 1.25 0 1 1 1.847-1.098",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const a = { render: t };
export {
  a as default,
  t as render
};
//# sourceMappingURL=ic_lock_open_filled-ypPJRF89.js.map
